module.exports = __webpack_public_path__ + "img/photo-station.6b699d62.svg";